<template>
    <div class="mx-auto" style="width: 85%">
        <h2 class="text-md-center">About Me</h2>
        <b-list-group>
            <h3 class="bg-info text-center">Objective Statement</h3>
            <b-card no-body>
                <p>To drive the forefront of the technical world through passion of technology, simplification of technical procedures, and growth of leadership</p>
            </b-card>
            <h3 class="bg-info text-center">Education</h3>
            <b-card no-body>
                <b-img center fluid class="img-item-style" :alt="'NKU Logo'"
                       :src="require('../assets/imgs/NKU.png')"/>
                <ul>
                    <li>Bachelor Degree: Computer Science</li>
                    <li>Minor Degree: Computer Information Technology</li>
                    <li>Honors: Graduated Cum Laude</li>
                    <li>GPA: 3.491</li>
                    <li>College: Northern Kentucky University</li>
                </ul>
            </b-card>
            <h3 class="bg-info text-center">Contact Information</h3>
            <b-card no-body>
                <p>Email: <a href="mailto:nolanpshumaker@gmail.com">nolanpshumaker@gmail.com</a></p>
                <p>Phone: 513-562-7157</p>
            </b-card>
            <h3 class="bg-info text-center">Download Resume</h3>
            <b-card no-body>
                <a href="https://drive.google.com/file/d/122YkWi3-_vKXxk-Hh4HVxAANfUNx_gIP/view?usp=sharing"
                target="_blank">
                    <b-img center fluid class="img-item-style" :alt="'Resume'"
                           :src="require('../assets/imgs/Resume.png')"/>
                </a>
            </b-card>
        </b-list-group>
    </div>
</template>

<script>
    export default {
        name: "Me"
    }
</script>

<style scoped>

</style>
